import {ADDUSER,CLEARUSER,USERSTATUS} from '../types'
export default {
  [ADDUSER](state,user){//废弃
    state.userName = user;
  },
  [CLEARUSER](state){
    state.userName = '';
  },
  [USERSTATUS](state,userName){
    if (userName) {
      state.userName = userName;
      state.isLogin = true;
    } else if (userName == null) {
      //登出的时候，清空sessionStorage里的东西
      sessionStorage.setItem("user",null);
      state.userName = null;
      state.isLogin = false
    }
  }
}